/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
    selector: '[driverComponentContainer]',
    standalone: false
})
export class DriverComponentContainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
